<template>
  <v-dialog v-model="open" width="450" persistent>
    <v-card class="event-form pb-2">
      <v-card-title class="p-3 mb-5" color="primary">
        <v-icon class="mr-3" @click="close">
          mdi-close
        </v-icon>
        {{ $t('ScheduledPublishEventsDialog.Title') }}
      </v-card-title>
      <v-card-text>
        <v-radio-group v-model="options.isScheduled" row>
          <v-radio :label="$t('ScheduledPublishEventsDialog.Option1')" name="option1" :value="true"></v-radio>
          <v-radio :label="$t('ScheduledPublishEventsDialog.Option2')" name="option2" :value="false"></v-radio>
        </v-radio-group>
        <v-row v-if="options.isScheduled" class="pt-4">
          <v-col md-6>
            <div class="v-input__control pb-3">
              <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="dateFormatted" :label="$t('NewCalendarItem.Date')" :hint="hintDateHormat"
                    persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker :locale="$i18n.locale" v-model="options.scheduledPublishDate" no-title
                  @input="menu1 = false"></v-date-picker>
              </v-menu>
            </div>
          </v-col>
          <v-col md-6>
            <SingleTimeDropdown :time="options.scheduledPublishTime" :round="false" @onTimeChange="onTimeChange">
            </SingleTimeDropdown>
            <div v-if="!isValidDateTime" class="error-msg">{{ $t('ScheduledPublishEventsDialog.InvalidDateOrTime') }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="submit">
          {{ $t('GeneralTranslations.Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <ConfirmDlg ref="confirmationModal"></ConfirmDlg>
  </v-dialog>
</template>

<script>
import moment from "moment/moment";
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';
import { dateFormats } from "@/consts/DateTimeFormats";
import SingleTimeDropdown from "@/components/pickers/SingleTimeDropdown.vue";

export default {
  name: 'ScheduledPublishEventsDialog',
  components: { ConfirmDlg, SingleTimeDropdown },
  props: {
    value: Boolean,
    data: Object
  },
  data() {
    return {
      isValidDateTime: true,
      hintDateHormat: '',
      options: {
        isScheduled: false,
        scheduledPublishTime: null,
        scheduledPublishDate: null,
        scheduledPublishDateTime: null
      }
    }
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },

    facility() {
      return this.$store.state.authModule.currentFacilityData
    },

    dateFormatted() {
      if (!this.hintDateHormat || !this.options.scheduledPublishDate) return ''
      const dateFormatted = moment(this.options.scheduledPublishDate).format(this.hintDateHormat)
      return dateFormatted
    }
  },

  watch: {
    async open(isOpen) {
      if (isOpen) {
        const dateFormat = dateFormats.find(x => x.format == this.facility.dateFormat)
        this.hintDateHormat = dateFormat ? dateFormat.name : dateFormats[0].name

        if (this.data && this.data.scheduledPublishDateTime) {
          this.options.isScheduled = !!this.data.scheduledPublishDateTime
          this.options.scheduledPublishDate = moment(this.data.scheduledPublishDateTime).format('YYYY-MM-DD')
          this.options.scheduledPublishTime = moment(this.data.scheduledPublishDateTime).format(this.$store.state.facilityModule.selectedFacility.timeFormat)
        }
        else {
          this.options.scheduledPublishDate = moment().add(1, "day").format('YYYY-MM-DD')
          this.options.scheduledPublishTime = null
        }

      }
    }
  },

  methods: {
    async submit() {

      if (!this.options.isScheduled) {
        this.options.scheduledPublishTime = null
        this.options.scheduledPublishDate = null
        this.options.scheduledPublishDateTime = null
        this.$emit('onScheduldEventsDialogResponse', this.options)
        return
      }

      this.options.scheduledPublishDateTime = this.getDateTime(this.options.scheduledPublishDate, this.options.scheduledPublishTime)
      
      if (!this.options.scheduledPublishDateTime) {
        this.isValidDateTime = false
        return
      }

      this.isValidDateTime = true

      this.$emit('onScheduldEventsDialogResponse', this.options)
    },

    onTimeChange(data) {
      this.options.scheduledPublishTime = data.time;
      this.isTimeValid = data.isValid;
    },

    getDateTime(dateString, timeString) {

      try {
        const today = moment();
        const dateTime = this.setDateTime(dateString, timeString);
        const isDateValid = dateTime.isValid() && dateTime.isSameOrAfter(today);

        if (isDateValid) {
          return dateTime.toDate()
        }
        else {
          return null
        }

      } catch (error) {
        return null
      }

    },

    setDateTime(dateString, timeString) {
      const dateTime = moment(`${dateString} ${timeString}`, `YYYY-MM-DD ${this.$store.state.facilityModule.selectedFacility.timeFormat}`);
      return dateTime;
    },

    close() {
      this.isValidDateTime = true

      this.options = {
        isScheduled: false,
        scheduledPublishTime: null,
        scheduledPublishDate: null,
        scheduledPublishDateTime: null
      }

      this.open = false
    }
  }
}
</script>

<style scoped></style>
